import axios from 'axios'

class SlackApiClient {
  constructor() {
    this.instance = axios.create({
      baseURL: process.env.REACT_APP_SLACK_API_URL,
    })
  }

  getChannels = async (token, nextCursor, allChannels = []) => {
    // const { data } = await this.instance.get(`/conversations.list`, {
    //   params: {
    //     token,
    //     exclude_archived: true,
    //     limit: 1000,
    //   },
    // })

    const params = {
      token,
      exclude_archived: true,
      limit: 1000,
    }

    if (nextCursor) {
      params.cursor = nextCursor
    }

    const { data } = await this.instance.get(`/conversations.list`, {
      params,
    })

    if (data.ok) {
      const nextCursor = data.response_metadata.next_cursor

      const cursorChannels = data.channels

      if (nextCursor) {
        return await this.getChannels(token, nextCursor, [
          ...allChannels,
          ...cursorChannels,
        ])
      } else {
        return [...allChannels, ...cursorChannels]
      }
    }
  }

  getChannel = async (token, id) => {
    const { data } = await this.instance.get(`/conversations.info`, {
      params: {
        token,
        channel: id,
      },
    })

    return data.ok ? data.channel : []
  }
}

export default SlackApiClient
